import { useQuery } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { getAppsList } from './apps';
import { queryKeys } from './queryKeys';

/**
 * The developer's apps (GET /dev-portal/apps), aggregated across shards by rivendell.
 * Org-scoped query key (re-fetches on org switch). Gated on `isReady` (token + org id both
 * synced from Prism) — firing before the org id lands would 400 and show an error/retry page.
 */
export function useApps() {
  const { token, orgId, isReady } = usePrismAuth();
  return useQuery({
    queryKey: queryKeys.apps.list(orgId),
    queryFn: () => getAppsList({ token, orgId }),
    enabled: isReady,
  });
}
